import React from 'react'
import { Tooltip, TooltipProps } from './tooltip'
import classNames from 'classnames'
import './tooltipWrapper.scss'

interface TooltipWrapperProps extends TooltipProps {
    children?: React.ReactNode
    className?: string
    revealOnFocus?: boolean
}

export const TooltipWrapper: React.FC<TooltipWrapperProps> = ({
    children,
    className,
    revealOnFocus,
    ...tooltipProps
}) => {
    return (
        <div className={classNames(className, 'tooltip-wrapper', { 'tooltip-wrapper--focus': revealOnFocus })}>
            {children}
            <Tooltip {...tooltipProps} />
        </div>
    )
}
